module.exports = __webpack_public_path__ + "img/ArrowOrange.a7d138dd.svg";